import {
    LabelBody,
    LabelHeader4,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import { useSyncedState } from '../../useSyncedState';
import { Rating } from './Rating';
import { RatingSlider } from './RatingSlider';

type Props = {
    ratings: Rating[];
    onContinue: (ratings: Rating[]) => void;
};
export function Page4({ ratings: r, onContinue }: Props) {
    const [ratings, setRatings] = useSyncedState(r);
    return (
        <>
            <LabelHeader4>Hvor bruger du din tid?</LabelHeader4>
            <LabelBody className="mt-10">
                Nu skal du rate, hvor meget tid, du bruger på de forskellige
                livsområder. 5 er det område, du bruger mest tid på og 1 er der,
                hvor du bruger mindst tid.
            </LabelBody>
            <div className="my-30 space-y-20">
                {ratings.map((rating) => (
                    <RatingSlider
                        key={rating.name}
                        rating={rating}
                        ratings={ratings}
                        onChangeRatings={setRatings}
                        minText={'Mindst tid'}
                        maxText={'Mest tid'}
                    />
                ))}
            </div>
            <SwirlyBox>Er du klar til at se dit kompas?</SwirlyBox>
            <Spacer className="mt-30" />
            <SecondaryButton onClick={() => onContinue(ratings)}>
                Videre til kompasset
            </SecondaryButton>
        </>
    );
}
